import { NumericId } from '@manigo/manigo-domain-typings';


export const FETCH_TRANSACTION_DETAILS = 'FETCH_TRANSACTION_DETAILS';
export const FETCH_TRANSACTION_DETAILS_SUCCESS = 'FETCH_TRANSACTION_DETAILS_SUCCESS';
export const FETCH_TRANSACTION_DETAILS_FAILURE = 'FETCH_TRANSACTION_DETAILS_FAILURE';
export const CLEAR_TRANSACTION_DETAILS = 'CLEAR_TRANSACTION_DETAILS';


export const CREATE_PAYMENT = 'CREATE_PAYMENT';
export const CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_FAILURE = 'CREATE_PAYMENT_FAILURE';


export const UPDATE_RECEIPT_TITLE = 'UPDATE_RECEIPT_TITLE';
export const UPDATE_RECEIPT_TITLE_SUCCESS = 'UPDATE_RECEIPT_TITLE_SUCCESS';
export const UPDATE_RECEIPT_TITLE_FAILURE = 'UPDATE_RECEIPT_TITLE_FAILURE';

export const DELETE_TRANSACTION_ATTACHMENT = 'DELETE_TRANSACTION_ATTACHMENT';
export const DELETE_TRANSACTION_ATTACHMENT_SUCCESS = 'DELETE_TRANSACTION_ATTACHMENT_SUCCESS';
export const DELETE_TRANSACTION_ATTACHMENT_FAILURE = 'DELETE_TRANSACTION_ATTACHMENT_FAILURE';

export const UPLOAD_RECEIPT_FILE = 'UPLOAD_RECEIPT_FILE';
export const UPLOAD_RECEIPT_FILE_SUCCESS = 'UPLOAD_RECEIPT_FILE_SUCCESS';
export const UPLOAD_RECEIPT_FILE_FAILURE = 'UPLOAD_RECEIPT_FILE_FAILURE';

export interface UploadReceiptFilePayload {
  transactionId: NumericId;
  file: { name: string; title: string; document: string };
}
